export const TEST_IDS = {
  FILTERS_BTN: 'filters-btn',
  APPLY_BTN: 'apply-btn',
  CANCEL_BTN: 'cancel-btn',
  CLEAR_BTN: 'clear-btn',
};
